// extracted by mini-css-extract-plugin
export default {"container":"subDepartment_container__eF+qE","section":"subDepartment_section__sPVso","filterContainer":"subDepartment_filterContainer__TCCmH","filter":"subDepartment_filter__DAwXG"};